import invokeClient from './invokeClient';
export const isDeviceConnected = () => {
    return invokeClient.invoke({
        functionName: 'isConnected',
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGV2aWNlQ29ubmVjdGVkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vbGliL2RldmljZUNvbm5lY3RlZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLFlBQVksTUFBTSxnQkFBZ0IsQ0FBQztBQUUxQyxNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxHQUFHLEVBQUU7SUFDcEMsT0FBTyxZQUFZLENBQUMsTUFBTSxDQUFDO1FBQ3pCLFlBQVksRUFBRSxhQUFhO0tBQzVCLENBQUMsQ0FBQztBQUNMLENBQUMsQ0FBQyJ9